/*
 * Copyright Robert Bosch GmbH. Copyright Robert Bosch GmbH. All rights reserved, also regarding any disposal, exploration, reproduction, editing, distribution, as well as in the event of applications for industrial property rights.
 */
import React ,{useEffect,useState} from "react";
import Card from "./Card";
import httpRequest from "../../Utils/httpRequest";
import { updateBreadcrumbs } from '../../redux/modules/app/actions';
import { connect } from 'react-redux';
import { withRouter} from 'react-router-dom';
const Subscription=(props)=>{
    const [loading,setIsLoading]=useState(true)
    const [subscriptionData,setsubscriptionData]=useState({})
    useEffect(()=>{
    props.dispatch(updateBreadcrumbs("Subscription"))
    httpRequest.get(
      'getSubscriptionData',
      {

      },
      DataSuccess,
      errorCallback,
      {
        
      },
    );
    },[])
    const DataSuccess=(data)=>{
        setIsLoading(false)
        setsubscriptionData(data.data)
    }
    const errorCallback=(err)=>{
        console.log(err)
        setIsLoading(false)
    }
    return(<>
    <div className="card-container">
    <Card count={subscriptionData?.totalUsers} status={'Total'}/>
    <Card count={subscriptionData?.active} status={'Active'}/>
    <Card count={subscriptionData?.inactive} status={'Inactive'}/>
    <Card count={subscriptionData?.overdue} status={'Overdue'}/>
    </div>
    </>)
}


const mapDispatchToProps = (dispatch) => ({
  updateBreadcrumbs,
  dispatch,
});
//method to connect react with redux   
export default withRouter(
  connect(null,mapDispatchToProps)(Subscription),
);